import { Injectable, OnDestroy } from '@angular/core';
import { AbstractCRUDService } from '@campaign-portal/components-library';
import { EntityField, InputComplexType, InputType } from '@campaign-portal/namespace/common/entityField';
import { ReadResponse } from '@campaign-portal/namespace/common/implementations';
import { FilterType } from '@campaign-portal/namespace/common/rpc.params';
import { BehaviorSubject, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ManualDippingFieldsService implements AbstractCRUDService, OnDestroy {
	readonly mdTaskID: EntityField = {
		id: 0,
		name: 'manual_dipping.id',
		variable: 'mdTaskID',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	// readonly sources: EntityField = {
	// 	id: 0,
	// 	name: 'manual_dipping.sources',
	// 	variable: 'sources',
	// 	filterType: FilterType.LIKE,
	// 	required: false,
	// 	type: InputType.TEXT
	// };
	readonly status: EntityField = {
		id: 1,
		name: 'manual_dipping.status',
		variable: 'status',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: []
	};
	readonly numbers: EntityField = {
		id: 2,
		name: 'manual_dipping.numbers',
		variable: 'numbers',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly author: EntityField = {
		id: 3,
		name: 'gl.author',
		variable: 'author',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: []
	};

	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [this.mdTaskID, this.status, this.numbers, this.author];

	constructor() {}

	ngOnDestroy(): void {
		this.loading$.complete();
	}

	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
	}

	create(): Observable<void> {
		return of();
	}

	update(): Observable<void> {
		return of();
	}

	delete(): Observable<void> {
		return of();
	}
}
